"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var OverlayImage = function OverlayImage(_ref) {
  var alt = _ref.alt,
    containerProps = _ref.containerProps,
    objectFit = _ref.objectFit,
    permitToShrink = _ref.permitToShrink,
    src = _ref.src;
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    style: permitToShrink ? {
      flexShrink: 1,
      overflow: 'hidden',
      textAlign: 'center'
    } : {}
  }, containerProps), /*#__PURE__*/_react["default"].createElement("img", {
    alt: alt,
    className: "sb-imageOverlay__img",
    src: src,
    style: {
      objectFit: objectFit
    }
  }));
};
var _default = exports["default"] = OverlayImage;